// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__IImPM","modalForm":"UpgradeEpcsModal_modalForm__3-KFz","modalFooter":"UpgradeEpcsModal_modalFooter__2c6J2"};